import BaseHandler from "../BaseHandler";
import { InfoConfigResponse } from "../../proto/InfoConfig_pb";
import store from "../../store";
import { setMessengerInfoConfig } from "../../store/messenger/actions";

export default class HandleInfoConfigResponse extends BaseHandler<InfoConfigResponse> {
  handle() {
    const infoConfigResponse = this.response.toObject();
    store.dispatch(setMessengerInfoConfig(infoConfigResponse));
  }
}
